<app-fcwidget></app-fcwidget>

<div [ngClass]="this.countryCode === 'PH' ? 'layout-height-ph user-layout-container' : 'user-layout-container'">
  <!-- QCA / N3 login (unchanged) -->
  <ng-container *ngIf="!isQi">
    <div [ngClass]="this.darkModeSwitch ? 'background-image' : 'background-image'">
      <img class="back" [src]="loginBackgroundUrl" alt="" role="presentation" fetchpriority="high"/>
      <img
        [src]="buttonImgUrl"
        class="img-btn"
        (click)="goToLink()"
      />
    </div>

    <!-- Mobile-only background replacement -->
    <div class="background-image-mobile">

      <video autoplay muted loop playsinline>
        <source [src]="loginBackgroundUrlMobile" type="video/mp4" />
      </video>

      <div class="video-blue-overlay" [class.active]="darkModeSwitch"></div>
      <img class="logo-mobile-image" src="https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-blue-512w.webp"
           srcset="https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-blue-512w.webp 512w, https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-blue.webp 1432w"
           sizes="160px"
           alt="QNE logo" width="160" height="40"/>

      <div class="hero-text">
        <div class="slide-left" [class.hero-text-dark]="darkModeSwitch" >unlock the <span style="color: #e4ab00">power of AI</span></div>
        <div class="slide-right" [class.hero-text-dark]="darkModeSwitch">for your business</div>
      </div>
    </div>

    <div [ngClass]="this.darkModeSwitch ? 'background-image' : 'background-image'">
      <img class="back" [src]="loginBackgroundUrl" alt="" role="presentation" fetchpriority="high"/>
      <img
        [src]="buttonImgUrl"
        class="img-btn"
        (click)="goToLink()"
      />
    </div>
  </ng-container>

  <!-- eIntegrator login only (classic design) -->
  <ng-container *ngIf="isQi">
    <div class="background-image qi-background-image">
      <img [src]="qiLoginBackgroundUrl" alt="" role="presentation" fetchpriority="high" />
    </div>

    <div class="background-image-mobile qi-background-image-mobile">
      <img [src]="qiLoginBackgroundUrl" alt="" role="presentation" fetchpriority="high" class="qi-back-mobile" />
    </div>

    <div class="header">
      <div class="qne-logo">
        <img alt="QNE logo" title="Logo" class="image1" [src]="logoYB" />
      </div>
      <div class="qne-logo-title-my">
        <h1 class="animate1">simplified E-Invoice:</h1>
        <h1 class="animate2">
          <span class="text-gold">AI</span> +
          <span class="text-gold">Cloud</span> power
        </h1>
      </div>
      <div class="qne-logo-subtitle">
        <h2 class="qne-logo-subtitle-heading">your partner in ensuring LHDN compliance!</h2>
      </div>
    </div>
  </ng-container>

  <div class="darkmode-switch" *ngIf="!isQi">
    <h3 id="dark-mode-label" [ngStyle]="this.darkModeSwitch ? {color:'#ffff'} : {color: '#00174d'}">Dark
      Mode</h3>
    <nz-switch appSwitchAriaLabel="Toggle dark mode" [attr.aria-labelledby]="'dark-mode-label'"
               [ngClass]="this.darkModeSwitch? 'darkmode-switch-handle' : ''" [(ngModel)]="this.darkModeSwitch"
               (ngModelChange)="darkModeSwitchClicked()"></nz-switch>
  </div>
  <div *ngIf="!isQi && this.darkModeSwitch"></div>
  <div class="icons">
    <div class="chat-container" *ngIf="widgetReady$ | async">
      <button type="button" class="chat" nz-button (click)="openChat()" nz-tooltip nzTooltipTitle="How Can I help you?"
              nzTooltipPlacement="left" [nzTooltipVisible]="true">
        <img src="https://qnestorage.blob.core.windows.net/qca/assets/img/Qbot-AI-Assistant-512.svg" />
      </button>
    </div>
    <div class="social-media">
      <a href="{{this.fblink}}" target="_blank" rel="noopener">
        <img alt="QNE Facebook" title="QNE Facebook"
             [ngClass]="this.darkModeSwitch ? 'fb-icon switch-icon-white' : 'fb-icon'"
             src="https://cdn.qne.cloud/qca/assets/img/fb-icon.webp"/>
      </a>

      <a href="{{this.iglink}}" target="_blank" rel="noopener">
        <img alt="QNE Instagram" title="QNE Instagram"
             [ngClass]="this.darkModeSwitch ? 'ig-icon switch-icon-white' : 'ig-icon'"
             src="https://cdn.qne.cloud/qca/assets/img/ig-icon.webp"/>
      </a>

      <a [href]="websiteLink()" target="_blank" rel="noopener">
        <img alt="QNE Website" title="QNE Website"
             [ngClass]="this.darkModeSwitch ? 'qne-icon switch-icon-white' : 'qne-icon'"
             src="https://cdn.qne.cloud/qca/assets/img/qne-icon.webp"/>
      </a>

    </div>
  </div>
  <div class="content-my">
    <div [ngClass]="isQi ? 'main-container' : (this.darkModeSwitch ? 'main-container mc-darkmode' : 'main-container')">
      <div class="main-top-btn" [ngClass]="isQi ? 'main-top-btn' : (this.darkModeSwitch ? 'main-top-btn mc-btn-darkmode' : 'main-top-btn')">
        <nz-tabset nzLinkRouter nzSize="large">
          <nz-tab>
            <a *nzTabLink nz-tab-link [routerLink]="['login']" queryParamsHandling="merge" [fragment]="this.fragment"
               class="txt-color">
              Log-In
            </a>
          </nz-tab>
          <nz-tab *ngIf="!isQi">
            <a *nzTabLink nz-tab-link [routerLink]="['register']" queryParamsHandling="merge"
               [fragment]="this.fragment">
              Sign Up
            </a>
          </nz-tab>
        </nz-tabset>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>

</div>

<div class="banner-mobile" *ngIf="!isQi">
  <img class="main" [src]="loginBannerMobile" alt="Logo" />
  <img
    [src]="buttonImgUrl"
    class="img-btn-mobile"
    (click)="goToLink()"
  />
</div>
<div [ngClass]="this.darkModeSwitch? 'light-bg passport-footer-ph': 'light-bg passport-footer-ph'"
     *ngIf="this.countryCode === 'PH'" >
  <div class="main-partners">
    <div class="acpapp-container">
      <p class="animate2">In partnership with:</p>
      <a href="https://www.qne.com.ph/qne-co-presenter-acpapp-2024/" target="_blank" rel="noopener">
        <img alt="ACPAPP partner logo" title="Logo" src="https://cdn.qne.cloud/qca/assets/img/ACPAPP.webp">
      </a>
    </div>
    <div class="acpaci-container">
      <img alt="ACPACI partner logo" title="Logo" src="https://cdn.qne.cloud/qca/assets/img/acpaci_logo.webp">
    </div>
  </div>
  <div [ngClass]="this.darkModeSwitch? 'lightmode-outline' : 'lightmode-outline'"></div>
  <div class="academe-partners-container">
    <p>Join the prestige list of Universities and Colleges in partnering with us to empower the
      future generation with the 1st AI Cloud Accounting in Southeast Asia
    </p>
    <div class="academe-partners-logos">
      <div class="academe-logos-ctn">
        <img alt="PUP partner logo" title="Logo" src="https://cdn.qne.cloud/qca/assets/img/academe/PUP.png">
        <img alt="CIT partner logo" title="Logo" src="https://cdn.qne.cloud/qca/assets/img/academe/CIT.png">
        <img alt="SSU partner logo" title="Logo" src="https://cdn.qne.cloud/qca/assets/img/academe/SSU.png">
        <a href="https://www.qne.com.ph/corporate-social-responsibility" target="_blank" rel="noopener"><b>and
          more...</b></a>
      </div>
    </div>
  </div>
</div>
<global-footer [links]="links" [ngClass]="this.darkModeSwitch? 'light-bg': 'light-bg'">
  <span>Copyright</span>
  <i class="anticon anticon-copyright"></i><span> {{ this.copyrightYear }} </span>
  <a href="{{ this.qnelink }}" target="_blank" rel="noopener" class="qne-link">{{ this.companyName }}</a>
</global-footer>
